//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class DataSetRootEntityModel extends ModelBase {
      static readonly $typeName = 'DataSetRootEntityModel';
      public dataEntityDisplayName: string;
      public dataEntityKey: string;
      public dataSetDisplayName: string;
      public dataSetKey: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/datawarehouse/models/DataSetRootEntityModel.ts